import { Popup as VanPopup } from 'vant';
import { randomUUID } from '@/utils';
import localeZh from './locale/zh-CN';
import localeEn from './locale/en';
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: 'en' // en/zh
    },

    title: {
      type: String,
      default: '国家编号'
    }
  },
  emits: ['update:modelValue', 'change'],
  components: {
    VanPopup
  },
  data() {
    return {
      activeAnchorIndex: -1,
      show: this.modelValue,
      inputMode: 0,
      keyword: ''
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme || ''; // 获取主题
    },

    isDark() {
      return this.theme === 'dark';
    },
    contentPlaceholder() {
      return this.$t('cfmoto.search');
    },
    safeAreaInsetTop() {
      if (this.isApple) {
        return 0;
      }
      const statusBarHeight = window.cfmoto.statusBarHeight();
      return `${statusBarHeight}`;
    },
    headerStyles() {
      if (this.isApple) {
        return {};
      }
      return {
        paddingTop: this.safeAreaInsetTop
      };
    },
    codeOptions() {
      const indexList = {
        zh: localeZh,
        en: localeEn
      }[this.locale] || localeEn;
      const sortIndexList = indexList.sort((item, item2) => item.value.charCodeAt() - item2.value.charCodeAt());
      return sortIndexList.map(item => ({
        ...item,
        children: item.children.map(citem => ({
          ...citem,
          id: randomUUID()
        }))
      }));
    },
    indexList() {
      return this.codeOptions.map(item => item.value);
    },
    searchOptions() {
      const codeOptions = JSON.parse(JSON.stringify(this.codeOptions));
      if (this.inputMode === 0) return codeOptions;
      const patternKeyword = new RegExp(this.keyword);
      return codeOptions.map(item => {
        item.children = JSON.parse(JSON.stringify(item.children)).filter(citem => patternKeyword.test(citem.label + citem.value));
        return item;
      });
    }
  },
  methods: {
    handleKeywordChange() {
      // input change 事件 比 点击删除事件先执行，等300ms
      setTimeout(() => {
        // const content = this.keyword;
        // if (!content) return;
        this.inputMode = 2;
      }, 300);
    },
    async handleFocus(event) {
      if (!event) {
        this.inputMode = 1;
        this.$refs.searchInput.focus();
        return;
      }
      this.inputMode = 1;
    },
    handleDelete() {
      this.keyword = '';
    },
    handleKeywordCancel() {
      this.inputMode = 0;
      this.keyword = '';
    },
    handleScroll(e) {
      let scrollTop = e.target.scrollTop;
      // console.log('【滚动距离】', scrollTop);
      // let ch = e.target.clientHeight;
      // console.log('【可视区域】', ch);
      // let sh = e.target.scrollHeight;
      // console.log('【滚动条高度】', sh);
      const anchorScrollTops = this.$refs.anchors.map(el => el.offsetTop);
      const fixedAhchorScrollTops = anchorScrollTops.filter(val => scrollTop > val);
      const activeAnchorIndex = anchorScrollTops.findIndex(val => val === fixedAhchorScrollTops[fixedAhchorScrollTops.length - 1]);
      this.activeAnchorIndex = activeAnchorIndex;
      // console.log(activeAnchorIndex);
      // console.log(this.$refs.anchors.map((el) => el.offsetTop));
    },

    handleScrollView(index) {
      this.$refs.anchors[index].scrollIntoView();
      this.activeAnchorIndex = index;
    },
    handleChange(item) {
      setTimeout(() => {
        this.$emit('change', item);
        this.show = false;
      }, 300);
    },
    handleCancel() {
      this.show = false;
      this.$emit('cancel');
    }
  },
  created() {
    this.show = this.modelValue;
  },
  mounted() {},
  beforeUnmount() {},
  watch: {
    modelValue(newValue) {
      this.show = newValue;
    },
    show(newValue) {
      this.$emit('update:modelValue', newValue);
    }
  }
};